import { useCallback } from "react";
import { useApi } from "@api/useApi";
import { changeLanguage } from "./index";

/**
 * `changeLanguage` bound to this region's API, so a language picked in the app is also stored on
 * the server for emails.
 */
export const useChangeLanguage = (): ((language: string) => Promise<void>) => {
  const api = useApi();

  return useCallback(
    (language: string) =>
      changeLanguage(language, (selected) => api.profile.setLanguage(selected)),
    [api],
  );
};
